export default __webpack_public_path__ + "static/DedicatedOpenSpaceFunding-bd5989ebfb8be0ec72f410a670d6ed71.jpg";